import axios from "axios"
 
// const token = JSON.parse(localStorage.getItem('token'))

export const api = axios.create({
  baseURL: process.env.REACT_APP_API
});

export default api;